module.exports = __webpack_public_path__ + "img/bg-kurt-kemple.953dd0cb.jpg";